import { store } from "@/commonui/store/index";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { ComponentMediaSlotModel, MediaTabService } from "@/services/media-tab";

@Module({ namespaced: true, name: "MediaState", store: store, dynamic: true })
export class MediaState extends VuexModule {
	componentMediaSlots: ComponentMediaSlotModel = { componentId: "", mediaSlots: [] };
	mediaTabLoading: boolean = false;

	@Action
	async fetchComponentMediaSlots(componentId: string) {
		this.setMediaTabLoading(true);
		const slots = await MediaTabService.getComponentMediaSlots({ componentId });
		this.setMediaTabLoading(false);
		this.setComponentMediaSlots(slots);
	}

	@Mutation
	setMediaTabLoading(value: boolean) {
		this.mediaTabLoading = value;
	}

	@Mutation
	setComponentMediaSlots(value: ComponentMediaSlotModel) {
		this.componentMediaSlots = { ...value };
	}
}

export const MediaModule = getModule(MediaState);
